import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from '../store/zustand';
import { Role } from '../enums/role.enum';
import { AFFILIATE_PARTNER_ROUTES } from '../constants';

const ProtectedRoute = () => {
  const location = useLocation();

  const isLoggedIn = useAuthStore((state) => state.isLoggedIn);
  const user = useAuthStore((state) => state.user);

  if (isLoggedIn === undefined) {
    return null;
  }

  const requiresAffiliatePartner = AFFILIATE_PARTNER_ROUTES.some(
    (route) =>
      location.pathname === route || location.pathname.startsWith(`${route}/`),
  );

  return isLoggedIn && user ? (
    requiresAffiliatePartner &&
    !user?.roles.includes(Role.AFFILIATE_PARTNER) ? (
      <Navigate to="/" />
    ) : (
      <Outlet />
    )
  ) : (
    <Navigate to="/login" />
  );
};

export default ProtectedRoute;
